<template>
    <h1 class="h2 text-white mb-3 d-none d-lg-block">
        {{ title }}
    </h1>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        required: true
    }
});
</script>

<style scoped>

</style>
